import React, { useEffect, useState } from 'react';

type TypeProps = {
  onChange: any;
  onBlur: any;
  inputPrice: any;
};

export const InputArea: React.FC<TypeProps> = (props: TypeProps) => {
  const { onChange, onBlur, inputPrice } = props;

  const isBlank = inputPrice === '';
  const isValid = /^[-]?(\d+)[.]?(\d+)?$/.test(inputPrice);

  const [isFocus, setFocus] = useState(false);

  const handleFocus = () => setFocus(true);

  return (
    <input
      type='text'
      onFocus={handleFocus}
      onChange={onChange}
      onBlur={() => {
        onBlur();
        setFocus(false);
      }}
      value={
        isFocus
          ? inputPrice === '0' || inputPrice === ''
            ? ''
            : inputPrice
          : (+inputPrice).toLocaleString() + '円'
      }
      style={{
        textAlign: 'right' as 'right',
        paddingRight: 5,
        backgroundColor: isValid || isBlank ? '#FFF' : '#FFBEDA',
        width: '100%'
      }}
    />
  );
};
